import {
  GetCustomTimeRangesDocument,
  UpdateCustomTimeRangeDocument,
  UpdateCustomTimeRangeMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useUpdateCustomTimeRange = () => {
  const [updateTimeRange, { loading }] = useMutation(UpdateCustomTimeRangeDocument, {
    extractorFn: (data) => data.attendanceMutations.bulkUpdateAttendanceCustomTimeRange,
  })

  const update = (variables: UpdateCustomTimeRangeMutationVariables) => {
    return updateTimeRange({
      variables,
      refetchQueries: [GetCustomTimeRangesDocument],
    })
  }

  return {
    loading,
    update,
  }
}
